export const payments = [
    { id: 1, value: 'CASH', title: 'Cash payment' },
    { id: 2, value: 'CARD', title: 'Pay by card' },
    { id: 3, value: 'WALLET', title: 'Pay with service limit wallet' },
    { id: 4, value: 'TRANSFER', title: 'Payment by bank transfer' },
];
